@if (canExport) {
  <div class="export-reports">
    <label class="export-label" for="export-report-type" i18n="@@export.label">Export to:</label>

    <p-dropdown
      inputId="export-report-type"
      styleClass="export-type"
      [options]="reportTypeOptions"
      [(ngModel)]="reportType"
      optionLabel="label"
      optionValue="value"
      [disabled]="isExporting"
      appendTo="body"
    ></p-dropdown>

    <button
      pButton
      type="button"
      class="export-button"
      [disabled]="isExporting"
      [loading]="isExporting"
      (click)="onExport()"
    >
      @if (isExporting) {
        <span i18n="@@export.building">Building report…</span>
      } @else {
        <span i18n="@@export.button">Export</span>
      }
    </button>

    @if (message) {
      <div class="export-message" role="alert">
        <span>{{ message }}</span>
        <button type="button" (click)="message = null" i18n-aria-label="@@closePanel" aria-label="Close">
          <i class="ri-close-fill"></i>
        </button>
      </div>
    }
  </div>
}
